import React from "react";
class About extends React.Component {
  render() {
    return (
      <main>
        <div className="mainBody">
          <div className="bannerBlock1">
            <div
              style={{
                position: "absolute",
                right: "0px",
                width: "250px",
                height: "150px",
                backgroundimage: "url(images/Services.png)",
                backgroundposition: "-0px -100px",
              }}
            ></div>
            <div className="bannerContent">
              <div class="content">
                <span class="pageTitle">IT CONSULTANCY</span>
                <br />
                <span class="subTitle">
                  Delivering strategic IT solutions powered by AI and modern technology
                  <br />
                  to transform your business operations...
                </span>
              </div>
            </div>
          </div>
          <div className="content padSmall">
            <p>
              At Sarithm, we provide strategic IT consulting services that combine deep technical 
              expertise with cutting-edge AI tools to help organizations navigate digital transformation, 
              optimize operations, and achieve their business objectives. We understand the demands of 
              modern IT environments and deliver solutions that drive real value.
            </p>
            <p>
              <b>AI-Powered Consulting Approach:</b> We leverage <b>Cursor</b> and other AI development tools 
              to accelerate our consulting deliverables, from architecture designs to implementation 
              strategies. <b>ChatGPT</b> and large language models assist us in generating comprehensive 
              documentation, analyzing requirements, and providing intelligent recommendations. 
              <b> n8n</b> enables us to create automated workflows that streamline client processes 
              and integrate disparate systems.
            </p>
            <p>
              <b>Enterprise Cloud Solutions:</b> In 2019, we partnered with <b>HPE</b> to develop the 
              User Interface for the <b>GreenLakes project</b>, HPE's public cloud offering. This 
              groundbreaking solution unified public and private clouds on a single management plane, 
              enabling users to interact seamlessly with AWS, GCP, Azure, and HPE private cloud 
              infrastructure. We contributed to building Infrastructure as Code (IaC) providers using 
              Terraform and Vault, demonstrating our expertise in modern cloud architecture.
            </p>
            <p>
              <b>High-Performing Team Building:</b> Over 4 years, we worked closely with multiple 
              HPE hiring managers to build high-performing teams, placing <b>100+ technical resources</b> 
              across various skill sets and levels. Our placements include UX/UI Engineers, Java Full-Stack 
              Developers, Software Engineers, Cyber Security Architects, SCRUM Masters, and Project Managers. 
              We understand that great technology requires great talent, and we excel at matching the right 
              professionals with the right opportunities.
            </p>
            <p>
              <b>Trusted Partnerships:</b> In 2024, we became a <b>Government Service Administrator (GSA)</b> 
              contract holder, a <b>State of Colorado</b> approved supplier, and a pre-approved vendor for 
              <b> JPMorgan Chase</b> and <b>United Airlines</b>. These partnerships reflect our commitment to 
              excellence, compliance, and delivering value to organizations of all sizes.
            </p>
            <p>
              <b>Strategic Technology Advisory:</b> Our consulting services encompass cloud migration 
              strategies, AI implementation roadmaps, infrastructure optimization, security assessments, 
              and digital transformation planning. We help organizations leverage AI tools like Cursor, 
              ChatGPT, and n8n to modernize their operations, improve efficiency, and stay competitive in 
              an evolving technology landscape.
            </p>
            <p>
              Whether you need strategic guidance, technical expertise, or talent acquisition support, 
              we provide IT consulting services that combine human insight with AI-powered tools to 
              deliver exceptional results.
            </p>
            <br />
            <br />
            <br />
          </div>
        </div>
        <div style={{ clear: "both" }}></div>
      </main>
    );
  }
}
export default About;
